<!-- Login.svelte -->

<script>
  import { onMount } from "svelte";
  document.title = 'Доставка';

  let selectedProductIds = [];
  let username = "";
  let password = "";
  let errorMessage = "";
  let informMessage = "";
  let isLoading = true;
  let isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  let sid = localStorage.getItem("sid") || "";
  let apiResponse = null;
  let vieList = false;
  let disabled = "disabled";
  let countSelectProduct = 0;
  let filter = false;
  let totalPrice = 0;
  $: {
    console.log(`${countSelectProduct}`);
    if (countSelectProduct > 0) {
      disabled = "";
    } else {
      disabled = "disabled";
    }
  }

  function handleProductClick(leadId, id, price) {
    // Проверяем, выбран ли уже товар
    const ind = selectedProductIds.findIndex((obj) => obj.leadId == leadId);
    const index = selectedProductIds[ind].products.indexOf(id);

    // Если товар уже выбран, убираем его из списка выбранных
    if (index !== -1) {
      countSelectProduct--;
      selectedProductIds[ind].products = selectedProductIds[
        ind
      ].products.filter((selectedId) => selectedId !== id);
      selectedProductIds[ind].price -= Number(price); 
      totalPrice -= Number(price); // Вычитаем цену удаленного товара
    } else {
      countSelectProduct++;
      // Если товар еще не выбран, добавляем его в список выбранных
      selectedProductIds[ind].products = [
        ...selectedProductIds[ind].products,
        id,
      ];
      selectedProductIds[ind].price += Number(price); // Добавляем цену выбранного товара
      totalPrice += Number(price); // Добавляем цену выбранного товара
    }
    console.log(selectedProductIds);
    console.log(`Total Price: ${totalPrice}`);

  }

  onMount(async () => {
    isLoading = false;
    // Функция set позволяет Svelte обнаруживать изменения в переменной
    window.setInformMessage = value => {
        informMessage = value; 
    };
  });

  async function handleSubmit() {
    if (isLoading) return;

    const data = await sendPostRequest(
      { user: username, pass: password },
      "deliveryAuth",
    );
    console.log(data);
    if (data.sid) {
      errorMessage = "";
      isLoggedIn = true;
      sid = data.sid;

      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("sid", data.sid);
      console.log("Вход выполнен успешно!");
    } else {
      errorMessage =
        "Неверные учетные данные. Пожалуйста, проверьте ваш логин и пароль.";
    }
  }

  function handleLogout() {
    isLoggedIn = false;
    apiResponse = null; // Сбросить ответ при выходе
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("sid");
  }

  async function sendPostRequest(data, point) {
    try {
      console.log(JSON.stringify(data));
      const response = await fetch(`http://93.170.247.76:3020/${point}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        const jsonResponse = await response.json();
        console.log("JSON ответ:", jsonResponse);
        if (point == "deliveryList") {
          apiResponse = jsonResponse; // Сохранить ответ для отображения
          apiResponse.forEach((element) => {
            const leadId = { leadId: element.leadId, price: 0, products: [] };
            selectedProductIds.push(leadId);
          });
        }
        if (point == "deliveryAuth") {
          console.log("POST запрос на Auth");
          if (jsonResponse.status == "ok") {
            return jsonResponse;
          } else {
            return "error";
          }
        }
      } else {
        console.error("Ошибка отправки POST запроса:", response.status);
      }
    } catch (error) {
      console.error(
        `Произошла ошибка при отправке POST запроса. Сервер недоступен`,
      );
      errorMessage = "Сервер недоступен";
      setTimeout(() => {
        errorMessage = "";
      }, 5000);
    }
  }

  async function handleViewDeliveries() {
    // Проверяем, залогинен ли пользователь
    if (isLoggedIn) {
      filter = false // Убираем фильтр
      apiResponse = null // Обнуляем старый ответ
      selectedProductIds = [] // Сбрасываем выбранные продукты
      disabled = "disabled" // Блокируем кнопку отправить
      totalPrice = 0; // Сбрасываем общую стоимость выбранных товаров
      countSelectProduct = 0;
      // Отправляем POST-запрос
      await sendPostRequest({ sid: sid }, "deliveryList");
      vieList = true;
      // Можно добавить дополнительную логику для обработки ответа сервера или обновления интерфейса
      console.log("Запрос на просмотр доставок отправлен.");
    } else {
      console.log(
        "Пользователь не залогинен. Выполните вход для просмотра доставок.",
      );
    }
  }

  async function emptyDeliveri(LeadId) {
    // Проверяем, залогинен ли пользователь
    if (isLoggedIn) {
      // Отправляем POST-запрос
      await sendPostRequest({ leadId: LeadId }, "emptyDelivery");
      // Можно добавить дополнительную логику для обработки ответа сервера или обновления интерфейса
      console.log("Отчет о пустой доставке отправлен.");
      informMessage='Данные о доставке отправлены';
      setTimeout(() => {
        informMessage = "";
      }, 3000);
      vieList = false;
    } else {
      console.log(
        "Пользователь не залогинен. Выполните вход для просмотра доставок.",
      );
    }
  }

  async function handleGoodDelivery(selectedProductIds) {
    console.log(selectedProductIds); 
    if (selectedProductIds) {
      // Отправляем POST-запрос с данными { delivery: reserved }
      await sendPostRequest(selectedProductIds, "successfulDelivery");
      // Можно добавить дополнительную логику для обработки ответа сервера или обновления интерфейса
      console.log("Выкупленные товары отправлены.");
      informMessage='Данные о доставке отправлены';
      setTimeout(() => {
        informMessage = "";
      }, 3000);
      vieList = false;
      filter = false // Убираем фильтр
      apiResponse = null // Обнуляем старый ответ
      selectedProductIds = [] // Сбрасываем выбранные продукты
      countSelectProduct = 0; // Обнуляем выбранные продукты
    } else {
      console.log("Не выбраны проданные товары.");
    }
  }

  function filterCardsByDate() {
    console.log("click");
    var selectedDate = document.getElementById("dateFilter").value;
    var cards = document.getElementsByClassName("container");

    for (var i = 0; i < cards.length; i++) {
      var cardDate = cards[i].getElementsByClassName("date")[0].innerText;
      if (cardDate !== selectedDate) {
        cards[i].style.display = "none";
      } else {
        cards[i].style.display = "block";
      }
    }
  }

  function filterActivate() {
    if (!filter){
      filter = true;
      setTimeout(populateDateFilter, 500);
    }
  }

  function populateDateFilter() {
    console.log("Start function populateDateFilter");
    let uniqueDates = [];
    let dateOptions = document.getElementById("dateFilter");

    let cards = document.getElementsByClassName("container");
    for (var i = 0; i < cards.length; i++) {
      console.log(cards);

      let cardDate = cards[i].getElementsByClassName("date")[0].innerText;
      console.log(cardDate);
      if (!uniqueDates.includes(cardDate)) {
        uniqueDates.push(cardDate);
        console.log(uniqueDates);

        let option = document.createElement("option");
        option.value = cardDate;
        option.text = cardDate;
        dateOptions.add(option);
      }
    }
  }


</script>

<h1>Личный кабинет</h1>

{#if isLoggedIn}
  <button on:click={handleLogout}>Выйти</button>
  <button on:click={handleViewDeliveries}>Посмотреть доставки</button>

  {#if errorMessage}
    <p style="color: red;">{errorMessage}</p>
  {/if}
  {#if informMessage}
  <p id="informMessage">{informMessage}</p>
{/if}
  {#if apiResponse && apiResponse.length > 0 && vieList}
    <button on:click={filterActivate}>Фильтр</button>
    {#if filter}
      <p>
        <select id="dateFilter" on:change={filterCardsByDate}>
          <option value="" disabled selected hidden>Выберите дату</option>
        </select>
      </p>
    {/if}
    {#each apiResponse as lead (lead.leadId)}
      <div class="container" id={lead.leadId}>
        <p>{lead.name}</p>
        <p>{lead.adres}</p>
        Дата доставки:
        <p class="date"><b>{lead.date}</b></p>
        <p>Время доставки: <b>{lead.deliveryTime}</b></p>
        <p>{lead.phone}</p>

        {#if lead.products && lead.products.length > 0}
          <p>Товары на доставку</p>
          {#each lead.products as product (product.id)}
            <ul>
              <li
                on:click={() => {
                  console.log(lead.leadId);
                  handleProductClick(lead.leadId, product.id, product.price);
                }}
                class:selected={selectedProductIds.some((obj) =>
                  obj.products.includes(product.id),
                )}
              >
                {product.name} - {product.price} руб. (Количество: {product.quantity})
              </li>
            </ul>
          {/each}

          <button {disabled} on:click={handleGoodDelivery(selectedProductIds)}
            >Продано</button
          >
          <button on:click={emptyDeliveri(lead.leadId)}>Ничего не купили</button
          >

        {:else}
          <p>Нет доступных продуктов.</p>
        {/if}
      </div>
    {/each}
  {:else if apiResponse && apiResponse.length == 0}
    <p>Нет доступных доставок</p>
  {:else if apiResponse == null}
    <p></p>
  {:else}
    <p></p>
  {/if}
{:else if isLoading}
  <p>Loading...</p>
{:else}
  <form on:submit|preventDefault={handleSubmit}>
    <label>
      Логин:
      <input type="text" bind:value={username} />
    </label>

    <label>
      Пароль:
      <input type="password" bind:value={password} />
    </label>

    {#if errorMessage}
      <p style="color: red;">{errorMessage}</p>
    {/if}

    <button type="submit">Войти</button>
  </form>
{/if}

<style>
  /* Ваш файл стилей (например, styles.css) */

  .container {
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 20px auto;
    padding: 20px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
  }

  p {
    margin: 5px 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 5px 0;
  }

  li {
    cursor: pointer;
    padding: 10px;
    border: 1px solid #ddd;
    margin-bottom: 4px;
    background-color: #fff;
    transition: background-color 0.3s ease;
  }

  li:hover {
    background-color: #f0f0f0;
  }

  li.selected {
    background-color: #336193;
    color: #fff;
  }

  button {
    background-color: #148692;
    color: #fff;
    padding: 10px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    margin-top: 12px;
  }

  button:hover {
    background-color: #16a0af;
  }

  button:disabled {
    cursor: not-allowed;
    background-color: #e7e7e7;
  }
  /* Стили для выпадающего списка */
  select {
    padding: 8px; /* Добавим отступы вокруг текста внутри элемента */
    font-size: 16px; /* Размер шрифта */
    border: 1px solid #ccc; /* Обводка */
    border-radius: 4px; /* Скругленные углы */
    appearance: none; /* Убираем стандартные стили браузера (не работает во всех браузерах) */
    background-color: white; /* Фон */
    width: 200px; /* Ширина элемента */
    appearance: none; /* Убрать галочку */
    -moz-appearance: none; /* Для Firefox */
    -webkit-appearance: none; /* Для WebKit (Chrome, Safari) */
  }

  /* Стили для опций в выпадающем списке */
  select option {
    padding: 8px;
    font-size: 14px;
  }

  /* Стиль при наведении курсора */
  select:hover {
    border-color: #7b7de3;
  }

  /* Стиль при фокусе */
  select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }

  #informMessage {
        /* background-color: #5baa5e; */
        /* background-color: #23272ae0; */
        background-color: #80ba27;
        
        color: #fff;
        padding: 7px;
        box-shadow: 0 0 4px rgba(0, 0, 0, 0.8);
        max-width: 300px;
        text-align: center;
        margin: 0 auto; /* Автоматический отступ слева и справа для центрирования по горизонтали */
        font-size: 14px;
      }
</style>
